// Direktiva na renderovanie eventDetail stranky
directives.eventDetailDirective.eventDetail = function() {
    var localizedTip1, localizedTip2, isProviderSpecialDetail, directive = {
        ".@class": function () {
            try {

                // Zisti ci sa jedna o LIVE event
                offer.eventLive = this.Event.LiveBetting;

                // Ulozi LeagueCupID daneho eventu
                offer.eventLeagueCupID = this.Event.LeagueCupID;

                isProviderSpecialDetail = false;

                // Zisti ci sa jedna o ligu/region ktora ma specialne zobrazenie detailu
                if (offer.vgL.specialDetail.includes(this.Event.LeagueCupID)) {
                    // Priprava pre zobrazenie matrixECT oddov v matici
                    isProviderSpecialDetail = true;
                    var matrixECT = new Object();
                    this.competitors = new Array();
                    this.competitorsWinners = new Array();
                }

                // Parsovanie titulkov
                this.Event.EventNames = this.Event.EventName.split(" vs. ");

                // Nastavenie tipNames na nazvy teamov
                if (profile.TipsFormat == "team" || profile.TipsFormat == "teamX") {
                    localizedTip1 = this.Event.EventNames[0];
                    localizedTip2 = this.Event.EventNames[1];
                } else {
                    localizedTip1 = texts["EventTip-1"];
                    localizedTip2 = texts["EventTip-2"];
                }

                // Parsovanie event detailu (LIVE / next LIVE / Prematch)
                this.Event = $.extend(this.Event, eventDetail.parseEvent(this.Event.LiveFeedReference, this.Event.LiveBetting, this.Event.SportID, this.Event.ActualGamePartID, this.Event.ActualGamePartTime, this.Event.EventDate, this.Event.EventID));

                // Parsovanie skore
                if (this.Event.SportEventID == -1 || this.Event.SportEventID == 0) {
                    // Sport
                    this.Event.SeSpID = this.Event.SportID;
                    this.Event.SeSpMark = "SP";
                } else {
                    // SportEvent
                    this.Event.SeSpID = this.Event.SportEventID;
                    this.Event.SeSpMark = "SE";
                }
                if (typeof this.Event.Score === "string") {
                    this.Event.Score = shared.parseScore(this.Event.Score, this.Event.SeSpID);
                }

                // Ak ma zapas prilezitosti
                if (Object.keys(this.EventChanceTypes).length) {
                    // Nastavi pocet oddov v ramci riadku
                    if (isProviderSpecialDetail) {
                        this.OddsInRow = 6;
                    } else {
                        this.OddsInRow = sets.oddsInRow;
                    }

                    // Zisti ci sa jedna o Victoria Competitor
                    if (this.EventChanceTypes[Object.keys(this.EventChanceTypes)[0]].BetType == "VICTORIA_COMPETITOR") {
                        this.Event.VictoriaCompetitor = true;

                        // Sortovanie tipov podla vysku kurzu (od najnizsi po najvyzsi)
                        this.Odds.sort(function (a, b) {
                            return a.OddsRate - b.OddsRate;
                        });

                        // Nastavi pocet oddov v ramci riadku pre Victoria Competitor
                        this.OddsInRow = sets.oddsInRowLT;

                        // Rozdeli chanceType na viacero chanceTypes a kluc rozsiri o TipID
                        this.Temp = this.EventChanceTypes;
                        this.EventChanceTypes = {};
                        for (i = 0; i < this.Odds.length; i++) {
                            this.EventChanceTypes[this.Odds[i].EventChanceTypeID + "_" + this.Odds[i].TipID] = $.extend(true, {}, this.Temp[this.Odds[i].EventChanceTypeID]);
                        }
                        delete this.Temp;
                    }

                    // Vygeneruje z BetradarTeams properties dalsie properties, ktorych nazov bude z originalu odseknuty po '_'
                    if (profile.FlatCSS && this.BetradarTeams) {
                        for (var key in this.BetradarTeams) {
                            if (this.BetradarTeams.hasOwnProperty(key)) {
                                this.BetradarTeams[key.split('_')[0]] = this.BetradarTeams[key];
                                if (key.includes('_10')) this.BetradarTeams['home'] = this.BetradarTeams[key];
                                if (key.includes('_20')) this.BetradarTeams['away'] = this.BetradarTeams[key];
                            }
                        }
                    }
                    var chanceType, actualRow, tipID;
                    // Prejde vsetky odds a rozparsuje do jednotlivych chanceTypes

                    // Premapovanie param groups
                    if (this.ChanceTypeParamGroups) {
                        this.ChanceTypeParamGroupsMapped = new Object();
                        here = this;
                        // TODO: Osetrit: 
                        this.ChanceTypeParamGroups.forEach(function(pg) {
                            here.ChanceTypeParamGroupsMapped[pg.ParamGroupID] = pg;
                        });
                        this.chanceTypesGrouped = [];
                    }

                    for (i = 0; i < this.Odds.length; i++) {

                        tipID = "";
                        // Ak sa jedna o Victoria Competitor tak nacita TipID
                        if (this.Event.VictoriaCompetitor) tipID = "_" + this.Odds[i].TipID;

                        // Priradenie chanceType na dany odd
                        if (chanceType = this.EventChanceTypes[(this.Odds[i].EventChanceTypeID + tipID)]) {

                            if (pgID = chanceType.ParamGroupID) {
                                // Grupovanie prilezitosti
                                if (!this.ChanceTypeParamGroupsMapped[pgID].Rows) this.ChanceTypeParamGroupsMapped[pgID].Rows = [];

                                if (chanceType.BetType == "DUO") this.OddsInRow = sets.oddsInRowLT;
                                // Prida riadok pokial neexistuje alebo predchadzajuci je uz plny
                                if ((actualRow = this.ChanceTypeParamGroupsMapped[pgID].Rows.length - 1) == -1 || this.ChanceTypeParamGroupsMapped[pgID].Rows[actualRow].Odds.length == this.OddsInRow) {
                                    // Prida ECT do daneho 'riadku' v groupe
                                    this.ChanceTypeParamGroupsMapped[pgID].Rows.push({Odds: []});
                                    actualRow++;
                                } else if (this.ChanceTypeParamGroupsMapped[pgID].Rows[actualRow] && this.ChanceTypeParamGroupsMapped[pgID].Rows[actualRow].EventChanceTypeID != chanceType.EventChanceTypeID) {
                                    this.ChanceTypeParamGroupsMapped[pgID].Rows.push({Odds: []});
                                    actualRow++;
                                }
                                // Prida odd do aktualneho riadku v danej chanceTypeGroup
                                this.ChanceTypeParamGroupsMapped[pgID].Rows[actualRow] = $.extend({}, this.ChanceTypeParamGroupsMapped[pgID].Rows[actualRow], chanceType);

                                this.ChanceTypeParamGroupsMapped[pgID].Rows[actualRow].Odds.push(this.Odds[i]);
                                // !this.ChanceTypeParamGroupsMapped[pgID].Rows[actualRow].isNotEmpty && 
                                if (this.Odds[i].Status === "active") {
                                    // Odd ktory je v ChanceType je aktivny => (nastavi ECT paramater isNotEmpty = true;)
                                    this.ChanceTypeParamGroupsMapped[pgID].Rows[actualRow].isNotEmpty = true;
                                    if (this.ChanceTypeParamGroupsMapped[pgID].Rows[actualRow].EventChanceTypeStatus === "active") {
                                        // ChanceType ktora je v paramGroupe je aktivna => (nastavi paramGroup paramater paramGroupIsNotEmpty = true;)
                                        this.ChanceTypeParamGroupsMapped[pgID].paramGroupIsNotEmpty = true;
                                    }
                                }

                                this.chanceTypesGrouped.push(chanceType.EventChanceTypeID);

                            } else {
                                // Negrupovane prilezitosti (Samostatne ECT)
                                if (isProviderSpecialDetail && chanceType.ChanceTypeID === "lvgWin") {
                                    this.competitorsWinners.push(this.Labels["TP_" + this.Odds[i].TipID].Name.split("#")[1]);
                                }
                                if (isProviderSpecialDetail && offer.matrixECT.includes(chanceType.ChanceTypeID)) {
                                    // Vytvorenie struktrury pre maticove usporiadanie oddov v ECT
                                    this.Odds[i].TIP = this.Labels["TP_" + this.Odds[i].TipID];
                                    // Zobrazenie chanceType oddov v matici
                                    var compCombination = this.Odds[i].TIP.Name.split('-');
                                    // Treba ulozit oboch competitorov (prazdne riadky v diagonaly matice)
                                    this.competitors.push(...compCombination);
                                    if (!matrixECT[chanceType.EventChanceTypeID]) {
                                        chanceType.matrix = new Object();
                                        matrixECT[chanceType.EventChanceTypeID] = chanceType;
                                    }

                                    if (!matrixECT[chanceType.EventChanceTypeID].matrix[compCombination[0]]) {
                                        matrixECT[chanceType.EventChanceTypeID].matrix[compCombination[0]] = new Object();
                                    }
                                    matrixECT[chanceType.EventChanceTypeID].matrix[compCombination[0]][compCombination[1]] = this.Odds[i];
                                } else {
                                    // reset nastavenia poctu riadkov pre chanceType odds
                                    if (isProviderSpecialDetail) {
                                        this.OddsInRow = 6;
                                    } else {
                                        this.OddsInRow = sets.oddsInRow;
                                    }

                                    // Vytvori pole riadkov
                                    if (!chanceType.Rows) chanceType.Rows = [];

                                    // Prida riadok pokial neexistuje alebo predchadzajuci je uz plny
                                    if ((actualRow = chanceType.Rows.length - 1) == -1 || chanceType.Rows[actualRow].Odds.length == this.OddsInRow) {
                                        chanceType.Rows.push({Odds: []});
                                        actualRow++;
                                    }

                                    // Prida odd do aktualneho riadku v danej chanceType
                                    chanceType.Rows[actualRow].Odds.push(this.Odds[i]);
                                    if (!chanceType.isNotEmpty && this.Odds[i].Status === "active")
                                        chanceType.isNotEmpty = true;
                                }
                            }
                        }
                    }
                    if (isProviderSpecialDetail && ((mEct = Object.keys(matrixECT)).length)) {
                        // Len unikatny competitori, doplnenie diagonaly pre prvok 0-0 (v datach exisutuju oddy pre 1. riadok, lenze treba pocitat s 1.stlpcom (hlavicka))
                        this.competitors = [...new Set(this.competitors)];
                        this.competitorsHeader = [0, ...this.competitors];
                        this.competitorsWinners = [...new Set(this.competitorsWinners)];
                        // Ulozenie
                        this.MatrixECT = matrixECT;
                    }

                    // Vymaze nezgrupovane CHT
                    if (this.chanceTypesGrouped && this.chanceTypesGrouped.length) {
                        this.chanceTypesGrouped.forEach(function(ectNotGrouped, index) {
                            delete here.EventChanceTypes[here.chanceTypesGrouped[index]];
                        });
                        this.EventChanceTypes = $.extend({}, this.EventChanceTypes, this.ChanceTypeParamGroupsMapped);
                    }

                    // Tlacidlo "Aktivne" a "Vsetko" v ChanceTypeGroup
                    if (this.Event.NextLive || (this.Event.LiveBetting === "Y" && !["notstarted", "nonstarted", "ended"].includes(this.Event.ActualGamePartID) && (this.Event.SportID !== offer.vgID || offer.vgL.uofTennis.includes(this.Event.LeagueCupID)))) {
                        allactiveChances = new Object();
                        allactiveChances.ChanceTypeGroupID = "allActive";
                        allactiveChances.ChanceTypeGroupName = texts.OfferGroupAllActive;
                        allactiveChances.ChanceTypes = [];
                        this.ChanceTypeGroups.unshift(allactiveChances);
                    }
                    if (this.Event.LiveBetting == "Y" && this.Event.SportID !== offer.vgID) {
                        // ChanceTypes zamknute sa zobrazuje pri LIVE
                        allLocked = new Object();
                        allLocked.ChanceTypeGroupID = "allLocked";
                        allLocked.ChanceTypeGroupName = texts.OfferGroupAllLocked;
                        allLocked.ChanceTypes = [];
                        this.ChanceTypeGroups.push(allLocked);
                    } else if (this.Event.EventType === 'special' && this.Event.SportID !== offer.vgID) {
                        // Pre overalove stavky nastavi chance group na default a nastavi jej nazov na 'Vsetko'
                        this.ChanceTypeGroups[0].ChanceTypeGroupID = "default-special";
                        this.ChanceTypeGroups[0].ChanceTypeGroupName = texts.OfferGroupDefault;
                    } else if (!isProviderSpecialDetail && !offer.vgL.krnHockey.includes(this.Event.LeagueCupID)) {
                        // Tab "vsetky" sa zobrazuju pre prematch (pre BTX virtualky su vypnute)
                        allChances = new Object();
                        allChances.ChanceTypeGroupID = "default";
                        allChances.ChanceTypeGroupName = texts.OfferGroupDefault;
                        allChances.ChanceTypes = [];
                        this.ChanceTypeGroups.unshift(allChances);
                    }


                    // Vytvorenie listu
                    var eventChanceTypes = [];
                    $.each(this.EventChanceTypes, function (i, ectOrGroup) {
                        // Vytvori list len s neprazdnymi parametrickymi skupinami
                        if (ectOrGroup.ParamGroupID && ectOrGroup.Rows && ectOrGroup.Rows.length) {
                            eventChanceTypes.push(ectOrGroup);
                        } else if (!ectOrGroup.ParamGroupID) {
                            eventChanceTypes.push(ectOrGroup);
                        }
                    });

                    // Sortovanie
                    var filteredChanceTypes = false;
                    if (stored.PlayerFavorite && stored.PlayerFavorite.chanceType && stored.PlayerFavorite.chanceType.length) {
                        filteredChanceTypes = stored.PlayerFavorite.chanceType.filter(function(ect) {
                            if (ect.sportId === here.Event.SportID && ((ect.liveBetting && here.Event.LiveBetting === "Y") || (!ect.liveBetting && here.Event.LiveBetting === "N"))) {
                                return ect;
                            }
                        });
                    }
                    this.EventChanceTypes = eventChanceTypes.sort(function (a, b) {
                        if (filteredChanceTypes.length) {
                            // Zapas obsahuje oblubene ECT
                            if (a.ParamGroupID && a.Rows[0] && a.Rows[0].ChanceTypeID) {
                                a.ChanceTypeID = a.Rows[0].ChanceTypeID;
                                a.Order = a.Rows[0].Order;
                            }
                            if (b.ParamGroupID && b.Rows[0] && b.Rows[0].ChanceTypeID) {
                                b.ChanceTypeID = b.Rows[0].ChanceTypeID;
                                b.Order = b.Rows[0].Order;
                            }
                            var hasFavoriteA = filteredChanceTypes.some(function(chT) {
                                if (a.ChanceTypeID && String(a.ChanceTypeID) === chT.chanceTypeId) {
                                    return true;
                                }
                            });

                            var hasFavoriteB = filteredChanceTypes.some(function(chT) {
                                if (b.ChanceTypeID && String(b.ChanceTypeID) === chT.chanceTypeId) {
                                    return true;
                                }
                            });
                            if (hasFavoriteA && hasFavoriteB) {
                                return a.Order - b.Order;
                            } else if (hasFavoriteA) {
                                return -1;
                            } else if (hasFavoriteB) {
                                return 1;
                            }
                        }
                        if (a.ParamGroupID && a.Rows && a.Rows[0]) {
                            a.Order = a.Rows[0].Order;
                        } else if (b.ParamGroupID && b.Rows && b.Rows[0]) {
                            b.Order = b.Rows[0].Order;
                        }
                        return a.Order - b.Order;
                    });

                    delete eventChanceTypes;

                    if (this.Event.VictoriaCompetitor) {
                        return "victoria-competitor";
                    }
                } else {
                    this.ChanceTypeGroups = [];
                }

                // Obsahuje BetBuilder, vytvori fiktivnu chance type group
                if (profile.BetBuilder && this.Event.BetBuilderID) {
                    var betBuilderChanceTypeGroup = new Object();
                    betBuilderChanceTypeGroup.ChanceTypeGroupID = "betbuilder";
                    betBuilderChanceTypeGroup.ChanceTypeGroupName = "<span class='icon-betbuilder'></span><span>&nbsp; Bet Builder</span>";
                    betBuilderChanceTypeGroup.BetBuilderID = this.Event.BetBuilderID;
                    betBuilderChanceTypeGroup.ChanceTypes = [];
                    this.ChanceTypeGroups.unshift(betBuilderChanceTypeGroup);
                }
                // [Betbuilder Aggregator API] Obsahuje BetBuilder Aggregator, vytvori fiktivnu chance type group
                if (profile.BetBuilderAgg && this.Event.HasBetbuilder) {
                    // Event je LIVE ale nie je povolený Betbuilder pre LIVE
                    if (this.Event.LiveBetting == "Y" && !profile.BetBuilderAggLive) {
                        return;
                    }
                    var betBuilderAggChanceTypeGroup = new Object();
                    betBuilderAggChanceTypeGroup.ChanceTypeGroupID = "betbuilder-agg";
                    betBuilderAggChanceTypeGroup.ChanceTypeGroupName = "<span class='icon icon-betbuilder--agg'></span><span>&nbsp; Bet Builder</span>";
                    betBuilderAggChanceTypeGroup.ChanceTypes = [];
                    this.ChanceTypeGroups.unshift(betBuilderAggChanceTypeGroup);
                }

            } catch (e) {
                console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                return false;
            }
        },
        ".@event-date": "Event.EventDate",
        ".@event-parent": function () {
            return this.EventID;
        },
        ".@live-betting": function () {
            if (this.Event.LiveBetting) return this.Event.LiveBetting;
        },
        ".@sport-name": function () {
            if (this.Event.SportName = this.Labels[this.Event.SeSpMark + "_" + this.Event.SeSpID].Name) return this.Event.SportName;
        },
        ".@region-name": function () {
            if (this.Event.RegionName = this.Labels["RE_" + this.Event.RegionID].Name) return this.Event.RegionName;
        },
        ".@leagueCup-name": function () {
            if (this.Event.LeagueCupName = this.Labels["LC_" + this.Event.LeagueCupID].Name) return this.Event.LeagueCupName;
        },
        ".main-icon.ui-icon-sports span": function () {
            if (this.Event.SportID != offer.vgID) {
                return this.Event.SportName;
            } else {
                return this.Event.RegionName;
            }
        },
        ".main-icon.ui-icon-sports@class+": " sport-icon-#{Event.SeSpID} sport-#{Event.SeSpID} region-#{Event.RegionID}",
        "#eventHeader@class": function () {
            var eventHeader = "";
            if (this.Event.SportID == offer.vgID) eventHeader = "virtual-event";
            if (!this.Event.EventNames[1] || this.Event.VictoriaCompetitor) {
                if (eventHeader) eventHeader += " ";
                eventHeader += "title-home-only";
            } else {
                if (eventHeader) eventHeader += " ";
                eventHeader += "title-home-away";
            }
            return eventHeader;
        },
        "#flatScoreDivider@class+": function () {
            if (profile.FlatCSS && this.Event.LiveBetting == "Y" && this.Event.Score) {
                return 'is-live-score';
            }
        },
        "#eventInfo@liveFeed-reference": function () {
        if (this.Event.HasMatchTracker && this.Event.BetradarStatisticsUrn?.length) {
                return this.Event.BetradarStatisticsUrn;
            }
        },
        "#eventInfo@stream-id": function () {
            if (stored.AllowStream && this.Event.Stream) return this.Event.Stream;
        },
        "#eventInfo@provider": function () {
            if (stored.AllowStream && this.Event.Provider) return this.Event.Provider;
        },
        "#eventInfo@class+": function () {
            if (this.Event.LiveBetting == "Y") {
                // Zobrazi LIVE a podla gamePartID nastavi farbu
                return ' is-live game-' + this.Event.ActualGamePartID;
            } else if (this.Event.NextLive) {
                // Zobrazuje ako nextLive len udalosti, ktore budu v LIVE v ramci akutalnej hodiny
                return ' next-live';
            }
        },
        "#eventInfo": function () {
            var eventInfo = "";
            if (this.Event.NextLive || this.Event.LiveBetting == "Y") {
                if (profile.FlatCSS) {
                    eventInfo = '<span id="eventInfoTitle" class="flat-live-mark">' + texts.MarkLive + '</span>';
                } else {
                    eventInfo = '<span id="eventInfoTitle">' + texts.MarkLive + '</span>';
                }
                if (this.Event.Label)
                    eventInfo += '<span id="eventInfoPart1">' + this.Event.Label + '</span>';
                if (this.Event.Time && this.Event.ActualGamePartTime != -1)
                    eventInfo += '<span id="eventInfoPart2"> &nbsp;' + this.Event.Time + '</span>';
            } else {
                eventInfo = '<span id="eventInfoTitle">' + texts.OddDate + ': </span>';
                if (this.Event.Date)
                    eventInfo += '<span id="eventInfoPart1">' + this.Event.Date + '</span>';
                if (this.Event.Time)
                    eventInfo += '<span id="eventInfoPart2"> &nbsp;' + this.Event.Time + '</span>';
            }
            return eventInfo;
        },
        "#titleHome": function () {
            if (!this.Event.VictoriaCompetitor) {
                return this.Event.EventNames[0];
            } else {
                if (this.Event.LongName = this.Event.RegionName) {
                    if (this.Event.LeagueCupName) this.Event.LongName += " - " + this.Event.LeagueCupName;
                }
                if (this.Event.LongName) return this.Event.LongName;
            }
        },
        "#titleHome@class": function () {
            if (profile.FlatCSS && profile.ShowStatistics && (profile.StatisticsParameter === "hasBetradarHostedStatistics") && this.BetradarTeams && !this.Event.VictoriaCompetitor && this.Event.SeasonID) {
                if (!offer.goldenLeague && this.BetradarTeams.home) return "has-stats";
            }
        },
        "#titleHome@onmousedown": function () {
            if (profile.FlatCSS && profile.ShowStatistics && (profile.StatisticsParameter === "hasBetradarHostedStatistics") && this.BetradarTeams && !this.Event.VictoriaCompetitor && this.Event.SeasonID) {
                if (!offer.goldenLeague && this.BetradarTeams.home) 
                return 'eventDetail.eventDetailStats(' + this.Event.BetradarSportID + ', "teamHome", ' + this.Event.SeasonID + ', ' + this.BetradarTeams.home + ')';
            }
        },
        "#logoHome@src": function () {
            if (profile.FlatCSS && this.BetradarTeams && !this.Event.VictoriaCompetitor) {
                var teamHomeFlagId = 0;
                if (this.BetradarTeams['home']) teamHomeFlagId = this.BetradarTeams['home'];
                return url.assetTeam + teamHomeFlagId + ".png";
            }
        },
        "#logoHome@onmousedown": function () {
            if (profile.FlatCSS && profile.ShowStatistics && this.BetradarTeams && !this.Event.VictoriaCompetitor && this.Event.SeasonID) {
                if (!offer.goldenLeague && this.BetradarTeams.home)
                return 'eventDetail.eventDetailStats(' + this.Event.BetradarSportID + ', "teamHome", ' + this.Event.SeasonID + ', ' + this.BetradarTeams.home + ')';
            }
        },
        "#vs": function () {
            if (this.Event.EventNames[1]) {
                return "VS ";
            }
        },
        "#logoAway@src": function () {
            if (profile.FlatCSS && this.BetradarTeams && !this.Event.VictoriaCompetitor) {
                var teamAwayFlagId = 0;
                if (this.BetradarTeams['away']) teamAwayFlagId = this.BetradarTeams['away'];
                return url.assetTeam + teamAwayFlagId + ".png";
            }
        },
        "#logoAway@onmousedown": function () {
            if (profile.FlatCSS && profile.ShowStatistics && (profile.StatisticsParameter === "hasBetradarHostedStatistics") && this.BetradarTeams && !this.Event.VictoriaCompetitor && this.Event.SeasonID) {
                if (!offer.goldenLeague && this.BetradarTeams.away)
                return 'eventDetail.eventDetailStats(' + this.Event.BetradarSportID + ', "teamAway", ' + this.Event.SeasonID + ', null, ' + this.BetradarTeams.away + ')';
            }
        },
        "#titleAway": function () {
            if (this.Event.EventNames[1])
                return this.Event.EventNames[1];
        },
        "#titleAway@class": function () {
            if (profile.FlatCSS && profile.ShowStatistics && (profile.StatisticsParameter === "hasBetradarHostedStatistics") && this.BetradarTeams && !this.Event.VictoriaCompetitor && this.Event.SeasonID) {
                if (!offer.goldenLeague && this.BetradarTeams.away) return "has-stats";
            }
        },
        "#titleAway@onmousedown": function () {
            if (profile.FlatCSS && profile.ShowStatistics && (profile.StatisticsParameter === "hasBetradarHostedStatistics") && this.BetradarTeams && !this.Event.VictoriaCompetitor && this.Event.SeasonID) {
                if (!offer.goldenLeague && this.BetradarTeams.away)
                return 'eventDetail.eventDetailStats(' + this.Event.BetradarSportID + ', "teamAway", ' + this.Event.SeasonID + ', null, ' + this.BetradarTeams.away + ')';
            }
        },
        "#scoreTotalH": function () {
            if (this.Event.Score && this.Event.Score.Home) return this.Event.Score.Home.total;
        },
        "#scoreHeader": function () {
            if (this.Event.Score && this.Event.Score.Home && this.Event.Score.Away && this.Event.EventNames[0] && this.Event.EventNames[1]) {
                return eventDetail.eventScoreTable(this.Event.Score, this.Event.SportID, this.Event.RegionID, "scoreHeader");
            }
        },
        "#scoreTotalA": function () {
            if (this.Event.Score && this.Event.Score.Away) return this.Event.Score.Away.total;
        },
        "#scoreParcialH": function () {
            if (this.Event.Score && this.Event.Score.Home && this.Event.EventNames[0]) {
                return "<span id='titleHomeScore'>" + shared.resolvePowerPlay(this.Event.Score, this.Event.SportID, "Home", true) + "<div id='titleHomeLabel'>" + this.Event.EventNames[0] + "</div></span>" + eventDetail.eventScoreTable(this.Event.Score, this.Event.SportID, this.Event.RegionID, "scoreHome");
            }
        },
        "#scoreParcialA": function () {
            if (this.Event.Score && this.Event.Score.Away && this.Event.EventNames[1]) {
                return "<span id='titleAwayScore'>" + shared.resolvePowerPlay(this.Event.Score, this.Event.SportID, "Away", true) + "<div id='titleAwayLabel'>" + this.Event.EventNames[1] + "</div></span>" + eventDetail.eventScoreTable(this.Event.Score, this.Event.SportID, this.Event.RegionID, "scoreAway");
            }
        },
        ".chances@class+": function () {
            if (this.Event.LiveBettingView == -1 && !["notstarted", "nonstarted"].includes(this.ActualGamePartID)) return " event-suspended";
        },
        "#chanceGroups table tr td": {
            "ChanceGroup<-ChanceTypeGroups": {
                ".@ID": "group-#{ChanceGroup.ChanceTypeGroupID}",
                "a@onclick": "eventDetail.eventDetailFilter('#{ChanceGroup.ChanceTypeGroupID}', true)",
                "a": function() {
                    if (profile.BetBuilder && this.ChanceTypeGroupID === "betbuilder") {
                        stored.eventNews = "betbuilder";
                        return this.ChanceTypeGroupName + "<div class='promo-dot'></div>";
                    } else if (this.ChanceTypeGroupID === "rapidbets") {
                        stored.eventNews = "rapidbets";
                        return this.ChanceTypeGroupName + "<div class='promo-dot'></div>";
                    }
                    return this.ChanceTypeGroupName;
                }
            }
        },
        "#detailBanner@onclick": function () {
            if (stored.eventNews)
                return "eventDetail.eventDetailFilter('" + stored.eventNews + "', true)";
        },
        "#detailBannerHeader": function () {
            switch (stored.eventNews) {
                case "betbuilder":
                case "rapidbets":
                    return texts.DetailBannerNews;
                default:
                break;
            };
        },
        "#detailBannerContent": function () {
            switch (stored.eventNews) {
                case "betbuilder":
                    return texts.DetailBannerBBContent;
                case "rapidbets":
                    return texts.DetailBannerRapidBetsContent;
                default:
                break;
            };
        },
        "#section": {
            "Chance<-EventChanceTypes": {
                ".@ID": function (a) {
                    if (a.Chance.item.ParamGroupID) {
                        return a.Chance.item.EventChanceTypeID;
                    } else if (this.EventChanceTypeID) {
                        return "ECT" + this.EventChanceTypeID;
                    }
                },
                ".@chanceType-ID": function () {
                    if (!this.ParamGroupID) {
                        return this.ChanceTypeID;
                    }
                },
                ".@paramGroup-ID": function () {
                    if (this.ParamGroupID) {
                        return this.ParamGroupID;
                    }
                },
                ".@pG-ChanceType-ID": function () {
                    if (this.Rows && this.Rows[0] && this.Rows[0].ChanceTypeID) {
                        return this.Rows[0].ChanceTypeID;
                    }
                },
                ".@favorite-state": function (a) {
                    if ((this.ectOrGroupID = String(this.ChanceTypeID? this.ChanceTypeID: this.ParamGroupID))) {
                         if (this.Rows && this.Rows[0].ChanceTypeID) {
                            this.ectOrGroupID = this.Rows[0].ChanceTypeID;
                        }
                        a.context.Event.LiveBetting === "Y"? this.liveBet = true: this.liveBet = false;
                        if (this.buttonState = player.playerFavoritesModule.favoriteButtonState(stored.favTypes.chanceType, a.context.Event.SportID, a.context.Event.LeagueCupID, a.context.Event.EventID, this.ectOrGroupID, this.liveBet)) {
                            return this.buttonState;
                        }
                    }
                },
                ".@betType": "Chance.BetType",
                ".@class+": function () {
                    if (offer.page !== "results" && stored.redirectTo !== "results") {
                        if (this.ParamGroupID) {
                            var paramGroupStatus = "group";
                            if (this.paramGroupIsNotEmpty) {
                                // Param group obsahuje aspon jednu active chanceType
                                paramGroupStatus += " chancegroup-is-not-empty";
                            } else {
                                // Param group neobsahuje ani jednu active chanceType
                                paramGroupStatus += " chancegroup-is-empty";
                            }
                            return paramGroupStatus;
                        } else {
                            if ((this.Order != 0 && this.EventChanceTypeStatus == "suspended") || (!this.isNotEmpty)) {
                                if (profile.ConsoleLog || profile.ConsoleLog$.LoadPure) {
                                    console.log('>   eventDetail - Not Active Chance Type: ' + this.ChanceTypeName + ' eventID: ' + offer.eventID);
                                }
                                return " chanceType-suspended chanceType-hidden";
                            } else if (this.EventChanceTypeStatus) {
                                return " chanceType-" + this.EventChanceTypeStatus;
                            }
                        }
                    }
                },
                "h4 .favorite-event@onmousedown": function (a) {
                    if (this.buttonState) {
                        return "player.playerFavoritesModule.editPlayerFavorite("
                        + a.context.Event.SportID + ", "
                        + a.context.Event.LeagueCupID + ", "
                        + a.context.Event.EventID + ", '"
                        + this.ectOrGroupID + "', "
                        + this.liveBet + ");";
                    }
                },
                "h4 .favorite-event@class+": function () {
                    if (this.buttonState) {
                        return this.buttonState;
                    } else {
                        return " ui-disabled";
                    }
                },
                "h4 .name": function (a) {
                    if (this.ParamGroupID && this.ParamGroupName) {
                        this.chanceTypeNameForOdds = this.ParamGroupName;
                        return this.ParamGroupName;
                    }
                    if (!a.context.Event.VictoriaCompetitor) {
                        this.chanceTypeNameForOdds = this.ChanceTypeName;
                        return this.ChanceTypeName;
                    } else {
                        if (a.context.Event.EventName && (this.ChanceTypeLongName = "<eventName>" + a.context.Event.EventName + "</eventName>")) {
                            if (this.ChanceTypeName) this.ChanceTypeLongName += " - ";
                        } else {
                            this.ChanceTypeLongName = "";
                        }
                        if (this.ChanceTypeName) {
                            this.ChanceTypeLongName += "<chanceTypeName>" + this.ChanceTypeName + "</chanceTypeName>"
                        }
                        this.chanceTypeNameForOdds = this.ChanceTypeLongName;
                        return this.ChanceTypeLongName;
                    }
                },
                "h4 .icon-wrapper@tooltip-containing-text": function () {
                    if (this.ToolTip && this.ToolTip !== "") {
                        return this.ToolTip;
                    }
                },
                "h4 .icon@class+": function () {
                    if (this.ToolTip && this.ToolTip !== "") {
                        return " icon-info-circle";
                    }
                },
                ".basic-ECT@class+": function(a) {
                    if (a.context.Event.Provider && !offer.vgL.krnHockey.includes(a.context.Event.LeagueCupID) && !offer.vgL.krnSoccers.includes(a.context.Event.LeagueCupID)) {
                        return " " + a.context.Event.Provider;
                    }
                },
                "table tr": {
                    "Row<-Chance.Rows": {
                        ".@ID": function (a) {
                            // Ak sa jedna o paramGroup, vrati EventChanceTypeID
                            if (a.Chance.item.ParamGroupID)
                                return "ECT" + this.EventChanceTypeID;
                        },
                        ".@chanceType-ID": function (a) {
                            // Ak sa jedna o paramGroup, vrati ChanceTypeID danej paramGroup-y
                            if (a.Chance.item.ParamGroupID)
                                return this.ChanceTypeID;
                        },
                        ".@chanceType-name": function (a) {
                            // Ak sa jedna o paramGroup
                            if (a.Chance.item.ParamGroupID)
                                return this.ChanceTypeName;
                        },
                        ".@bettype": function (a) {
                            // Ak sa jedna o paramGroup
                            if (a.Chance.item.ParamGroupID)
                                return this.BetType;
                        },
                        ".@class": function (a) {
                            var chance = "";
                            if (a.Chance.item.ParamGroupID) {
                                // Vo vnutry paramGroup sa nachadza ECT
                                chance += "chance";
                                if (offer.page !== "results" && stored.redirectTo !== "results") {
                                    if ((this.EventChanceTypeStatus == "suspended")) {
                                        chance += " chanceType-suspended chanceType-hidden";
                                    } else {
                                        chance += " chanceType-" + this.EventChanceTypeStatus;
                                        if (a.context.EventChanceTypes[a.Chance.pos].Rows[a.Row.pos].Odds.every(function(odd) {return odd.Status == "suspended";})) {
                                            chance += " chanceType-hidden";
                                        }
                                    }
                                }
                                return chance;
                            }
                        },
                        "td": {
                            "Odd<-Row.Odds": {
                                "a@odd-status": function() {
                                    return this.Status;
                                },
                                "a@odd-betbuilder-agg": function() {
                                    // [Betbuilder Aggregator API] Deleguje logiku do betbuilderAgg modulu
                                    return betbuilderAgg.checkOddAvailability(this.OddsID);
                                },
                                "a@odd-visibility": function() {
                                    if (offer.page !== "results" && stored.redirectTo !== "results") {
                                        switch (this.Status) {
                                            case 'suspended':
                                                return 'locked';
                                            break;
                                            case 'active':
                                                return 'showed';
                                            break;
                                            default: 
                                                // closed, inactive, suspended
                                                return 'hidden';
                                            break;
                                        }
                                    }
                                },
                                "a@ID": "Odd.OddsID",
                                "a@competitorID": function () {
                                    if (this.CompetitorID) return this.CompetitorID;
                                },
                                "a@onclick": "ticket.ticketOddModule.ctAddOdd(#{Odd.OddsID}, '#{Chance.BetType}')",
                                "a@class": function (a) {
                                    if (!this.OddsID) {
                                        return "hide-odd";
                                    }
                                    if (a.context.IsResult || stored.redirectTo === "results") {
                                        // Jedna sa o zobrazenie vysledkov
                                        if (this.OddsWinning == "Y") {
                                            return "winning-odd";
                                        } else {
                                            return "not-winning-odd";
                                        }
                                    } else {
                                        var oddClass = "";
                                        if (this.Status) {
                                            // odd status
                                            oddClass = " odd-" + this.Status;
                                        }
                                        if (ticket.listCheck(this.OddsID)) {
                                            // odd na tikete
                                            oddClass += " ui-btn-up-e";
                                        }
                                        return oddClass;
                                    }
                                },
                                "a@chancetype-name": function (a) {
                                    // [Betbuilder Aggregator API] Nazov ChanceType pre dany odd (z premennej chanceTypeNameForOdds) - pouzivam pre vybrane oddy v betbuilder-agg 
                                    return a.context.EventChanceTypes[a.Chance.pos].chanceTypeNameForOdds;
                                },
                                /* TODO - toto sa asi nepužíva
                                "#teamLogo@style+": function (a) {
                                    if (profile.FlatCSS) {
                                        if (this.CompetitorID && a.context.BetradarTeams && Object.keys(a.context.BetradarTeams).length) {
                                            var teamId = a.context.BetradarTeams[this.CompetitorID];
                                            return " background-image:" + "url(" + url.assetTeam + teamId + ".png)";
                                        }
                                    }
                                }, */
                                "#teamLogo": function (a) {
                                    if (profile.FlatCSS) {
                                        if (this.CompetitorID && a.context.BetradarTeams && Object.keys(a.context.BetradarTeams).length) {
                                            if (a.context.Event.EventType === "special") {
                                                var teamId = a.context.BetradarTeams[this.CompetitorID];
                                                return `<img src="${url.assetTeam}${teamId}.png" alt="teamId:${teamId}" onerror="eventDetail.eventDetail.eventLogoError(this);" width="27" height="27" />`;
                                            }
                                        }
                                    }
                                },
                                "#tipName": function (a) {
                                    // Ak sa jedna o VICTORIA_PLAYER prida hracov (potrebne pre statistiky)
                                    if (this.PlayerID) {
                                        if (this.BetradarPlayerID && this.CompetitorID) {
                                            var betRadarPlayer = {
                                                betRadarPlayerID: this.BetradarPlayerID,
                                                playerName: a.context.Labels["PL_" + this.PlayerID].Name,
                                                seasonID: a.context.Event.SeasonID,
                                                teamID: a.context.BetradarTeams[this.CompetitorID]
                                            }
                                            if (a.context.BetradarTeams[(this.CompetitorID) + "_10"]) {
                                                if (!stored.BetRadarStats.playersID.includes(String(this.BetradarPlayerID))) {
                                                    stored.BetRadarStats.playersID.push(String(this.BetradarPlayerID));
                                                    stored.BetRadarStats.playersHome.push(betRadarPlayer);
                                                }
                                            }
                                            if (a.context.BetradarTeams[(this.CompetitorID) + "_20"]) {
                                                if (!stored.BetRadarStats.playersID.includes(String(this.BetradarPlayerID))) {
                                                    stored.BetRadarStats.playersID.push(String(this.BetradarPlayerID));
                                                    stored.BetRadarStats.playersAway.push(betRadarPlayer);
                                                }
                                            }
                                        }
                                    }
                                    // Odd obsahuje id param groupy
                                    var actualParamGroupID = a.Chance.item.ParamGroupID;

                                    if (actualParamGroupID) {
                                        // Zisti aktualnu paramGroup
                                        paramGroup = a.context.EventChanceTypes[a.Chance.pos]
                                        // Zisti aktualne prechadzanu chanceType vo vnutri paramGroup
                                        chanceType = a.context.EventChanceTypes[a.Chance.pos].Rows[a.Row.pos];
                                    } else {
                                        // Odd je bez param group
                                        chanceType = a.context.EventChanceTypes[a.Chance.pos];
                                    }
                                    this.name = "";
                                    if (chanceType) {
                                        if (chanceType.BetType == "VICTORIA_PLAYER" && a.context.Labels["PL_" + this.PlayerID]) {
                                            this.name = a.context.Labels["PL_" + this.PlayerID].Name;
                                            if (a.context.Event.Provider === offer.providerNameUOF && a.context.Labels["TP_" + this.TipID].Name) {
                                                this.name = a.context.Labels["TP_" + this.TipID].Name + " - " + this.name;
                                            }
                                        } else if (chanceType.BetType == "VICTORIA_COMPETITOR" && a.context.Labels["CP_" + this.CompetitorID]) {
                                            this.name = a.context.Labels["CP_" + this.CompetitorID].Name;
                                            if (a.context.Event.Provider == offer.providerNameKRN && a.context.Labels["TP_" + this.TipID]) {
                                                this.name = a.context.Labels["TP_" + this.TipID].Name + " - " + this.name;
                                            }
                                        } else {
                                            this.name = a.context.Labels["TP_" + this.TipID].Name;
                                        }

                                        // Riesi nazov oddu pre vsetky ECT (ci uz samostatne alebo v paramGroup)
                                        if (!profile.TipsFormat) {
                                            this.nonParamGroupTipName = this.name;
                                            return this.name;
                                        } else {
                                            switch (this.name) {
                                                case "1":
                                                    this.name = localizedTip1;
                                                    break;
                                                case "X":
                                                    this.name = texts["EventTip-X"];
                                                    break;
                                                case "2":
                                                    this.name = localizedTip2;
                                                    break;
                                                case "1X":
                                                    if (profile.TipsFormat === "teamX") {
                                                        this.name = "1X";
                                                    } else {
                                                        this.name = localizedTip1 + " " + texts["EventTip-OR"] + " " + texts["EventTip-X"];
                                                    }
                                                    break;
                                                case "X2":
                                                    if (profile.TipsFormat === "teamX") {
                                                        this.name = "X2";
                                                    } else {
                                                        this.name = texts["EventTip-X"] + " " + texts["EventTip-OR"] + " " + localizedTip2;
                                                    }
                                                    break;
                                                case "12":
                                                    if (profile.TipsFormat === "teamX") {
                                                        this.name = "12";
                                                    } else {
                                                        this.name = localizedTip1 + " " + texts["EventTip-OR"] + " " + localizedTip2;
                                                    }
                                                    break;
                                                default:
                                                    break;
                                            }
                                            this.nonParamGroupTipName = this.name;
                                            if (!actualParamGroupID) {
                                                return this.name;
                                            }
                                        }
                                    }
                                    if (actualParamGroupID) {
                                        // Vrati nazov pre aktualne prechadzany odd (plati len pre oddy v parametrickych skupinach)
                                        if (this.ParamLimitMark) {
                                            this.name += " " + this.ParamLimitMark;
                                          } else {
                                            var paramLimit = chanceType.ParamLimit;
                                            if (paramGroup.TipClutch) {
                                                this.name += " " + paramGroup.TipClutch + " ";
                                            } else if (
                                              paramGroup.HandicapMarker === "-" ||
                                              paramGroup.HandicapMarker === "+"
                                            ) {
                                                this.name += " " + paramGroup.HandicapMarker;
                                              paramGroup.HandicapMarker =
                                                paramGroup.HandicapMarker === "-" ? "+" : "-";
                                            } else if (paramGroup.HandicapMarker === "Y") {
                                              if (paramLimit?.charAt(0) !== "-") {
                                                paramLimit = " +" + paramLimit;
                                              } else {
                                                paramLimit = " " + paramLimit;
                                              }
                                              paramGroup.HandicapMarker = "N";
                                            } else if (paramGroup.HandicapMarker === "N") {
                                              if (paramLimit?.charAt(0) !== "-") {
                                                paramLimit = " -" + paramLimit;
                                              } else {
                                                paramLimit = " +" + paramLimit.substring(1);
                                              }
                                              paramGroup.HandicapMarker = "Y";
                                            } else {
                                                this.name += " ";
                                            }
                                            this.name += paramLimit;
                                          }
                                          return this.name;
                                    }
                                },
                                "#tipNameNonGroup": function (a) {
                                    // Nazov oddu akoby nepatril do parametrickej skupiny (potrebne pre spravne zobrazenie nazvu v tikete pred synchronizaciou)
                                    if (a.Chance.item.ParamGroupID) {
                                        return a.context.EventChanceTypes[a.Chance.pos].Rows[a.Row.pos].Odds[a.Odd.pos].nonParamGroupTipName;
                                    }
                                },
                                "#tipImage": function (a) {
                                    if (isProviderSpecialDetail) {
                                        return virtual.assignCompetitorImage((a.Chance.item.BetType == "VICTORIA_COMPETITOR")? this.TipType: this.name, a.context.Event.Provider, a.context.Event.LeagueCupID);
                                    }
                                },
                                "#statsIcon@onclick": function (a) {
                                    if (profile.FlatCSS && profile.ShowStatistics && (profile.StatisticsParameter === "hasBetradarHostedStatistics") && this.BetradarPlayerID && (offer.sportID !== offer.vgID)) return 'eventDetail.eventDetailStats(' + a.context.Event.BetradarSportID + ', "player", ' + a.context.Event.SeasonID + ', ' + a.context.BetradarTeams[this.CompetitorID] + ' , null, ' + this.BetradarPlayerID + ')';
                                },
                                "#statsIcon@class": function () {
                                    if (profile.FlatCSS && profile.ShowStatistics && (profile.StatisticsParameter === "hasBetradarHostedStatistics") && this.BetradarPlayerID && (offer.sportID !== offer.vgID)) return "h2h-ico";
                                },
                                "#crs": function () {
                                    if (this.OddsRate) return this.OddsRate.toFixed(2);
                                },
                                "#crs@class": function () {
                                    if (this.OddsRate <= 1) return "no-crs";
                                }
                            }
                        }
                    }
                }
            }
        },
        "#matrixSection": {
            "mECT<-MatrixECT": {
                ".@ID": function () {
                    rowIndex = 0;
                    colIndex = 0;
                    if (this.EventChanceTypeID) {
                        return "ECT" + this.EventChanceTypeID;
                    }
                },
                ".@chanceType-ID": function () {
                    if (this.ChanceTypeID) {
                        return this.ChanceTypeID;
                    }
                },
                ".@betType": function() {
                    if (this.BetType) {
                        return "MATRIX-" + this.BetType;
                    }
                },
                ".@class+": function () {
                    return " chanceType-" + this.EventChanceTypeStatus;
                },
                ".matrix-ECT@class+": function(a) {
                    if (a.context.Event.Provider) {
                        // Zmrstene zobrazenie v pripade ze udalost ma viacerych competitorov
                        return ((a.context.competitors.length > 8)? " has-many-competitors ": " ") + a.context.Event.Provider;
                    }
                },
                "h4 .name": function () {
                    if (this.ChanceTypeName) {
                        return this.ChanceTypeName;
                    }
                },
                "th.first-place-competitor-header": { 
                    "compHeader<-competitorsHeader": {
                        "div": function (a) {
                            if (a.compHeader.item) {
                                return virtual.assignCompetitorImage(a.compHeader.item, a.context.Event.Provider, a.context.Event.LeagueCupID);
                            } else if (a.compHeader.item === 0 && a.mECT.item.ChanceTypeID === "vg_12s.for") {
                                // Pridanie legendy v maticovom zobrazeni ECT
                                return '<div class="competitor-legend"><span id="competitorLegend1" class="competitor-legend-label">' 
                                + texts.CompetitorSecondPlace + '<div class="ui-icon ui-icon-main icon-arrow-right"></div></span><span id="competitorLegend2" class="competitor-legend-label">'
                                + texts.CompetitorFirstPlace + '<div class="ui-icon ui-icon-main icon-arrow-down"></div></span></div>';
                            }
                        }
                    }
                },
                "tr.matrix-row": {
                    "compNameRow<-competitors": {
                        "@class+": function () {
                            rowIndex++;
                            colIndex = 0;
                            return " competitor-second-" + rowIndex;
                        },
                        "tr th.second-place-competitor-header": function (a) {
                            if (rowIndex && a.item) {
                                // a.item je poradove cislo competitora, rowIndex je iteracny index
                                return virtual.assignCompetitorImage(a.item, a.context.Event.Provider, a.context.Event.LeagueCupID);
                            }
                        },
                        "td.matrix-cell": {
                            "compNameCol<-competitors": {
                                ".@competitor-name": function (a) {
                                    colIndex++;
                                    return "competitor-" + a.compNameRow.item + "-" + a.compNameCol.item;
                                },
                                "@class+": function (a) {
                                    if (a.mECT.item.matrix[a.compNameRow.item] && a.mECT.item.matrix[a.compNameRow.item][a.compNameCol.item] && a.mECT.item.matrix[a.compNameRow.item][a.compNameCol.item].OddsRate) {
                                        // Bunky s kurzami
                                        return " has-rate";
                                    } else {
                                        // Ostatne bunky ktore maju byt prazdne
                                        return " empty";
                                    }
                                },
                                "a@onclick": function(a) {
                                    if (a.mECT.item.matrix[a.compNameRow.item] && a.mECT.item.matrix[a.compNameRow.item][a.compNameCol.item] && a.mECT.item.matrix[a.compNameRow.item][a.compNameCol.item].TipID) {
                                        return "ticket.ticketOddModule.ctAddOdd(" + a.mECT.item.matrix[a.compNameRow.item][a.compNameCol.item].OddsID + ", '" + a.mECT.item.BetType + "')";
                                    }
                                },
                                "a@id": function (a) {
                                    if (a.mECT.item.matrix[a.compNameRow.item] && a.mECT.item.matrix[a.compNameRow.item][a.compNameCol.item] && a.mECT.item.matrix[a.compNameRow.item][a.compNameCol.item].OddsID) {
                                        return a.mECT.item.matrix[a.compNameRow.item][a.compNameCol.item].OddsID;
                                    }
                                },
                                "#tipName": function (a) {
                                    if (a.mECT.item.matrix[a.compNameRow.item] && a.mECT.item.matrix[a.compNameRow.item][a.compNameCol.item]) {
                                        return a.compNameRow.item + "-" + a.compNameCol.item;
                                    }
                                },
                                "#crs": function (a) {
                                    if (a.mECT.item.matrix[a.compNameRow.item] && a.mECT.item.matrix[a.compNameRow.item][a.compNameCol.item] && a.mECT.item.matrix[a.compNameRow.item][a.compNameCol.item].OddsRate) {
                                        // Bunky s kurzami
                                        return shared.floor2(a.mECT.item.matrix[a.compNameRow.item][a.compNameCol.item].OddsRate, 2);
                                    } else {
                                        // Ostatne bunky ktore maju byt prazdne
                                        return "&nbsp;";
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    T.eventDetail = $p("#event #chances").compile(directive);
};
